import { render } from "./ContactUsPageCMS.vue?vue&type=template&id=1e98e67a"
import script from "../js/contact-us-page-cms?vue&type=script&lang=js"
export * from "../js/contact-us-page-cms?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__